module.exports = "<div><div class=\"modal hidden\"><div class=modal-bg></div><div class=modal-content><div class=\"container t-center\"><p>{{ 'WECHAT_SCAN' | translate }}</p><p><img src=/assets/img/weechat-qr.gif alt></p><p>{{ 'WECHAT_DIRECTLY' | translate }}：<br>NOWNESS_OFFICIAL</p></div></div></div><nn-close-modal-button modal-name=wechat></nn-close-modal-button></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modals/nn-wechat-modal/nn-wechat-modal.directive.html
// module id = 985
// module chunks = 0